import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface DeleteDocumentDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  documentName: string;
}

/**
 * DeleteDocumentDialog Component
 *
 * Confirmation dialog for document deletion with destructive action button.
 *
 * @param open - Whether the dialog is open
 * @param onClose - Callback to close the dialog
 * @param onConfirm - Callback when deletion is confirmed
 * @param documentName - Name of the document to be deleted
 */
export function DeleteDocumentDialog({
  open,
  onClose,
  onConfirm,
  documentName,
}: DeleteDocumentDialogProps) {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-[#15203C] border-[#5D5D5D] max-w-[500px] p-[30px]">
        <DialogHeader className="mb-[20px]">
          <div className="flex items-start gap-[16px]">
            <div className="flex-shrink-0 w-[48px] h-[48px] rounded-full bg-[#DC4426]/10 flex items-center justify-center">
              <AlertTriangle className="size-[24px] text-[#DC4426]" />
            </div>
            <div>
              <DialogTitle className="text-[20px] font-bold text-white font-['Plus_Jakarta_Sans'] mb-[8px]">
                Excluir Documento
              </DialogTitle>
              <p className="text-[14px] text-[#F6F6F6] font-['Plus_Jakarta_Sans']">
                Tem certeza que deseja excluir o documento{" "}
                <span className="font-semibold text-white">"{documentName}"</span>?
              </p>
              <p className="text-[14px] text-[#888888] font-['Plus_Jakarta_Sans'] mt-[8px]">
                Esta ação não pode ser desfeita.
              </p>
            </div>
          </div>
        </DialogHeader>

        <div className="flex items-center justify-end gap-[12px] mt-[24px]">
          <Button
            variant="outline"
            onClick={onClose}
            className="bg-transparent border-[#5D5D5D] text-[#F6F6F6] hover:bg-white/5"
          >
            Cancelar
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            className="bg-[#DC4426] hover:bg-[#DC4426]/80 text-white"
          >
            Excluir Documento
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
